import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { switchLanguagePath } from '../../utils/urlHelper';

// Selector de idioma del header: «ES | EN» directo, sin desplegable ni
// banderas (nov-2026, home B2B). La ruta equivalente sale de la tabla común de
// urlHelper (URL_MAPPINGS); sin equivalente, la home del otro idioma.
const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const languages = [
    { code: 'es', label: 'ES', name: 'Español' },
    { code: 'en', label: 'EN', name: 'English' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (langCode) => {
    // Pulsar el idioma activo no hace nada.
    if (langCode === currentLanguage.code) return;
    const newPath = switchLanguagePath(location.pathname, langCode);
    i18n.changeLanguage(langCode);
    navigate(newPath);
  };

  return (
    <div className="flex items-center text-sm font-semibold" role="group" aria-label="Idioma / Language">
      {languages.map((language, idx) => {
        const active = currentLanguage.code === language.code;
        return (
          <React.Fragment key={language.code}>
            {idx > 0 && <span className="mx-1 text-gray-300" aria-hidden="true">|</span>}
            <button
              type="button"
              onClick={() => handleLanguageChange(language.code)}
              lang={language.code}
              title={language.name}
              aria-label={language.name}
              aria-current={active ? 'true' : undefined}
              className={`px-1 py-1 tracking-wide transition-colors ${
                active ? 'text-gray-900' : 'text-gray-400 hover:text-primary-700'
              }`}
            >
              {language.label}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default LanguageSelector;